export default __webpack_public_path__ + "static/media/SquaresFour.1b6a0360.svg";